import React from 'react';

const Select = React.forwardRef(({ options = [], className = "", placeholder, ...props }, ref) => {
    return (
        <select
            ref={ref}
            {...props}
            className={`p-2 border rounded w-full ${className}`}
        >
            {placeholder && (
                <option value="" disabled hidden>
                    {placeholder}
                </option>
            )}
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
});

export default Select;
